import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { CodeDialogBoxComponent } from '../code-dialog-box/code-dialog-box.component';

@Component({
  selector: 'app-code-type-dialog-box',
  templateUrl: './code-type-dialog-box.component.html',
  styleUrls: ['./code-type-dialog-box.component.scss'],
})
export class CodeTypeDialogBoxComponent implements OnInit {
  codetypeForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  codetypeList: any;
  list;
  APIService: any;
  CodeDisabled = true;
  isReadonly = false;
  isReadonlyDelete = false;
  deleteButton: boolean;
  selectedIndex: number = 0;
  dialogRef: MatDialogRef<any>;
  CodeCreate = true;
  CodeUpdate = true;
  CodeDelete = true;
  CodeTypeView = true;
  userPermission: any;
  utp: string;
  constructor(
    public umsService: UmsService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,
    private dialogRef1: MatDialogRef<CodeTypeDialogBoxComponent>,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.APIService = environment.serviceUrl;
  }

  @ViewChild(CodeDialogBoxComponent, { static: false })
  private CodeData: CodeDialogBoxComponent;

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach((element) => {
        if (element.PageName == 'Code-Type' && element.PCreate == false) {
          this.CodeCreate = false;
        }
        if (element.PageName == 'Code-Type' && element.PUpdate == false) {
          this.CodeUpdate = false;
        }
        if (element.PageName == 'Code-Type' && element.PDelete == false) {
          this.CodeDelete = false;
        }
        if (element.PageName == 'Code' && element.PView == false) {
          this.CodeTypeView = false;
        }
      });
    }
    window.scroll(0, 0);
    this.list = true;
    this.submitButton = true;
    this.editButton = false;
    this.codetypeForm = this.fb.group({
      CdType: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
      ]),
      CdCode: new FormControl('99999', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
        Validators.maxLength(6),
      ]),
      CdDesc: new FormControl('', [Validators.required]),
      CdSeq: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(4),
      ]),
      CdActive: new FormControl('Y'),
      CdProc: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),
      ]),
    });

    this.getCodeTypeData();
    if (this.data.key == 'Edit') {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == 'Delete') {
      this.prepopulationForDelete(this.data.selected);
    }
  }

  prepopulation(id) {
    this.isReadonly = true;
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.CodeDisabled = false;
    sessionStorage.setItem('CdType', id.CdType);
    sessionStorage.setItem('CdDesc', id.CdDesc);
    sessionStorage.setItem('CdCode', id.CdCode);
    this.codetypeForm = this.fb.group({
      CdType: new FormControl(id.CdType, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
      ]),
      CdCode: new FormControl(id.CdCode, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
        Validators.maxLength(6),
      ]),
      CdDesc: new FormControl(id.CdDesc, [Validators.required]),
      CdSeq: new FormControl(id.CdSeq, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(4),
      ]),
      CdActive: new FormControl(id.CdActive, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9]*$'),
      ]),
      CdProc: new FormControl(id.CdProc, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),
      ]),
    });
    this.redirect('code-type');
  }

  update() {
    if (this.codetypeForm.invalid) {
      this.codetypeForm.get('CdType').markAsTouched();
      this.codetypeForm.get('CdCode').markAsTouched();
      this.codetypeForm.get('CdDesc').markAsTouched();
      this.codetypeForm.get('CdSeq').markAsTouched();
      this.codetypeForm.get('CdActive').markAsTouched();
      this.codetypeForm.get('CdProc').markAsTouched();
      return;
    } else {
      this.updateCodeType();
    }
  }

  updateCodeType() {
    this.spinner.show();
    this.submitpayload = this.codetypeForm.value;
    this.umsService.updateCodeType(this.submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          sessionStorage.setItem('CdType', this.submitpayload.CdType);
          sessionStorage.setItem('CdDesc', this.submitpayload.CdDesc);
          sessionStorage.setItem('CdCode', this.submitpayload.CdCode);
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  getCodeTypeData() {
    this.spinner.show();
    const payload = {};
    payload['IsActive'] = '0';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.codetypeList = res.data;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      this.CodeDisabled = false;
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  prepopulationForDelete(id) {
    sessionStorage.setItem('CdType', id.CdType);
    sessionStorage.setItem('CdDesc', id.CdDesc);
    sessionStorage.setItem('CdCode', id.CdCode);
    this.editButton = false;
    this.isReadonlyDelete = true;
    this.isReadonly = true;
    this.submitButton = false;
    this.deleteButton = true;
    this.CodeDisabled = false;
    this.codetypeForm = this.fb.group({
      CdType: new FormControl(id.CdType, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
      ]),
      CdCode: new FormControl(id.CdCode, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
        Validators.maxLength(6),
      ]),
      CdDesc: new FormControl(id.CdDesc, [Validators.required]),
      CdSeq: new FormControl(id.CdSeq, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(4),
      ]),
      CdActive: new FormControl(id.CdActive, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9]*$'),
      ]),
      CdProc: new FormControl(id.CdProc, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),
      ]),
    });
  }
  openConformationModalBox() {
    let data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.deletedata(this.codetypeForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }

  deletedata(id) {
    this.spinner.show();
    const payload = {};
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        CdType: id.CdType,
        CdCode: id.CdCode,
        CdDesc: id.CdDesc,
        CdSeq: id.CdSeq,
        CdActive: id.CdActive,
        CdProc: id.CdProc,
      },
    };
    this.httpClient
      .delete(this.APIService + '/masters/code-types', options)
      .subscribe(
        (s) => {
          this.spinner.hide();
          let cc = [];
          cc.push(s);
          let data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef1.close();
          });
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.ngOnInit();
          this.dialogRef1.close();
        }
      );
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.CodeDisabled = false;
      this.getCodeTypeData();
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(CodeTypeDialogBoxComponent, {
      width: '150vh',
      data: { key: 'New' },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getCodeTypeData();
    });
  }

  submit() {
    if (this.codetypeForm.invalid) {
      this.codetypeForm.get('CdType').markAsTouched();
      this.codetypeForm.get('CdCode').markAsTouched();
      this.codetypeForm.get('CdDesc').markAsTouched();
      this.codetypeForm.get('CdSeq').markAsTouched();
      this.codetypeForm.get('CdActive').markAsTouched();
      this.codetypeForm.get('CdProc').markAsTouched();
      return;
    } else {
      this.createCodeType();
    }
  }

  createCodeType() {
    this.spinner.show();
    this.submitpayload = this.codetypeForm.value;
    const payload = this.codetypeForm.value;
    this.umsService.addCodeType(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          sessionStorage.setItem('CdType', this.submitpayload.CdType);
          sessionStorage.setItem('CdDesc', this.submitpayload.CdDesc);
          sessionStorage.setItem('CdCode', this.submitpayload.CdCode);
          this.enable();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  onTabChanged(event: MatTabChangeEvent) {
    if (event.tab.textLabel == 'Code') {
      let k = sessionStorage.getItem('CdType');
      this.CodeData.ngOnInit();
      this.CodeData.getCodeData(k);
    }
  }
  
  enable() {
    this.CodeDisabled = false;
  }

  public next() {
    this.selectedIndex += 1;
    this.CodeData.ngOnInit();
  }
  
  public prev() {
    this.selectedIndex -= 1;
  }
}

